const locationPincodePickerValidRoutes = [
    "one-step-evaluation"
];

export const isValidRouesForPincode = (routeName) => {
    return locationPincodePickerValidRoutes.includes(routeName);
};
